import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FindColleagueComponent } from '../../find-colleague/find-colleague.component';

@Component({
  selector: 'app-find-colleague-widget',
  templateUrl: './find-colleague-widget.component.html',
  styleUrls: ['./find-colleague-widget.component.scss'],
})
export class FindColleagueWidgetComponent  implements OnInit {

  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {}
  async openFindColleagueModal() {
    const modal = await this.modalController.create({
      component: FindColleagueComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      canDismiss: async (data, role) => role != 'gesture',
      componentProps: {
      },
    });
    // modal.onDidDismiss().then((result) => {
    //   if (result.data) {
    //     // this.meetingDetails.participants = result.data;
    //   }
    // });
    modal.present();
    }
}
